const User = ({ user, ...rest }) => {
  const u = user || {};
  const countryCode = rest.country_code;
  const isEligibleForFreeTrial = u.is_eligible;
  const isAuthenticated = u.etp_guid !== undefined;
  const isDirectToPay = isAuthenticated && !isEligibleForFreeTrial;

  return {
    id: u.etp_guid,
    sessionId: rest.session_id,
    username: u.username,
    email: u.email,
    createdAt: u.created_at,
    accessType: u.access_type,
    isPremium: u.is_premium,
    isEligibleForFreeTrial,
    countryCode,
    locale: rest.locale,
    isAuthenticated,
    isDirectToPay,
  };
};

export { User };
